import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

const Receptions = ({moduleType}) => {
  return (
    <div className="mb-3 m-1">
      <div className="card">
        <div className="card-header text-center">
          Recepción de ingresos o devoluciones
        </div>
        <div className="card-body">
          <div className="row">
            <div className="text-center">
              <h3>17</h3>
              <div className="col-sm text-center">Recepción de devolución</div>
            </div>
            <div className="text-center">
              <h3>21</h3>
              <div className="col-sm text-center">Recepción de ingreso</div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm text-center mt-3 mb-1">
              <Link to={`/admin/warehouse/receptions/${moduleType}`}>
                <Button variant="contained" color="primary">
                  Ver detalle
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receptions;

Receptions.propTypes = {
  title: PropTypes.string,
  closeModal: PropTypes.bool,
  id_therapy: PropTypes.number,
  id_paquetizacion: PropTypes.number
};
